export default __webpack_public_path__ + "62f4a9251f6ccedbd77315a2c7008eed.jpg";